"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ready = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var FileUpload_1 = require("../../FileUpload");
var Button_1 = require("./Button");
var Wrapper_1 = require("./Wrapper");
var models_1 = require("./models");
var ButtonBlock = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 8px;\n"], ["\n  margin-top: 8px;\n"])));
var Ready = function (_a) {
    var onFileSelect = _a.onFileSelect, propertyId = _a.propertyId, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.displayError, displayError = _c === void 0 ? false : _c, color = _a.color, accept = _a.accept;
    return (react_1.default.createElement(Wrapper_1.Wrapper, { padding: '8px 16px', disabled: disabled, error: displayError },
        react_1.default.createElement(FileUpload_1.FileName, { color: color }, "\u30D5\u30A1\u30A4\u30EB\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093"),
        react_1.default.createElement(ButtonBlock, null,
            react_1.default.createElement(Button_1.FileUploadButton, { disabled: disabled, propertyId: propertyId, onFileSelect: onFileSelect, label: models_1.BUTTON_LABEL_READY, error: displayError, accept: accept }))));
};
exports.Ready = Ready;
var templateObject_1;
